<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <template v-if="showDialog === null" v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template>
      <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>{{message}}</v-card-text>
        <v-card-actions v-if="onOK">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="onKO">{{$t('common.cancel')}}</v-btn>
          <v-btn color="green darken-1" text @click="onOK">{{$t('common.ok')}}</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="onKO">{{$t('common.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    props: {
      showDialog: {
        type: Boolean,
        required: false,
        default: null
      },
      title: {
        type: String,
        requerido: false,
        default: null
      },
      message: {
        type: String,
        requerido: false,
        default: null
      },
      onKO: {
        type: Function,
        required: false,
        default: null
      },
      onOK: {
        type: Function,
        required: false,
        default: null
      }
    },
    data () {
      return {
        dialog: false,
      }
    },
    watch: {
      showDialog: {
        handler: function (newValue) {
          this.dialog = newValue
        },
        deep: true
      }
    },
    mounted() {
      if (this.showDialog !== null) this.dialog = this.showDialog
    },
  }
</script>